// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31eAk","inner":"Footer_inner__33tkA"};